import { render, staticRenderFns } from "./LegendBtnTemplate.vue?vue&type=template&id=78191985&"
import script from "./LegendBtnTemplate.vue?vue&type=script&lang=js&"
export * from "./LegendBtnTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports